import { http } from "../api/http";

export const userPermissionGroupService = {
  getGroupsForUser,
  getUsersInGroup,
  assign,
  remove,
};

async function getGroupsForUser(userId) {
  let url = `/userpermissiongroup/user/${userId}`;
  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function getUsersInGroup(groupId) {
  let url = `/userpermissiongroup/group/${groupId}`;
  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function assign(data) {
  let url = "/userpermissiongroup";
  return await http.post(url, data).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function remove(userId, groupId) {
  let url = `/userpermissiongroup?userId=${userId}&groupId=${groupId}`;
  return await http.delete(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}
